// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { DocumentsInstance } from "./helpers/documentsInstanceHelpers";
import { createDocumentsInstance } from "./helpers/documentsInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseNotary, DocumentsInstance>({
	name: "Documents",
	createBase: createBaseNotary,
	createInstance: createDocumentsInstance,
});

export function getDocumentsInstance(): DocumentsInstance {
	return factory.getInstance();
}
